import { InertiaLinkProps } from '@inertiajs/react';
import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}

export function isSameUrl(
    url1: NonNullable<InertiaLinkProps['href']>,
    url2: NonNullable<InertiaLinkProps['href']>,
) {
    const resolved1 = resolveUrl(url1);
    const resolved2 = resolveUrl(url2);

    return getPathname(resolved1) === getPathname(resolved2);
}

export function resolveUrl(url: NonNullable<InertiaLinkProps['href']>): string {
    return typeof url === 'string' ? url : url.url;
}

function getPathname(url: string): string {
    try {
        const urlObj = new URL(url, window.location.origin);
        // For absolute URLs, include origin + pathname
        // For relative URLs, just pathname
        if (url.startsWith('http://') || url.startsWith('https://')) {
            return urlObj.origin + urlObj.pathname;
        }
        return urlObj.pathname;
    } catch {
        // Fallback: manually strip query params and hash
        return url.split('?')[0].split('#')[0];
    }
}

export function formatDate(isoDate: string): string {
    return new Intl.DateTimeFormat('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
    })
        .format(new Date(isoDate))
        .replace(/,/g, ''); // Remove any commas if present
}

export function formatDateTime(isoDate: string): string {
    return new Intl.DateTimeFormat('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    }).format(new Date(isoDate));
}

export function currencyFormat(cents: number) {
    return `€ ${(cents / 100).toFixed(2)}`;
}
